import FlutterAction from '../FlutterAction';

type Response = { success: boolean };

const action = new FlutterAction<void, Response, boolean>('biometric', async response => response.success);

export default action;
